// Keep legacy /home links on the supported dashboard implementation. The
// previous copy had drifted from the dashboard API and duplicated rendering
// helpers that no longer existed.
module.exports = require('./dashboards');
